import React, { CSSProperties, useState } from 'react';
import dayjs from 'dayjs';
import styled, { keyframes } from 'styled-components';
import { Col, Row, truncateString } from '../../../../lib/utils';
import { Body3Bold, Body3Light, Body3Regular, CaptionBold, CaptionLight } from '../../../../lib/font';
import { LEGACY_WEEKLY_BLOCK_HEIGHT } from '../layout';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HoverItem = styled.div<{ isVisible: boolean }>`
    width: 300px;
    min-height: 178px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    position: absolute;
    border-radius: 16px;
    box-shadow: 4px 4px 8px 0px rgba(15, 23, 42, 0.18);
    border: 1px solid #fcd34d;
    padding: 14px 24px 16px 16px;
    z-index: 99;
    animation: ${(props) => (props.isVisible ? fadeIn : 'none')} 1s ease forwards;
`;

const NewOpportunityBlock = ({ childItem, cellIndex, onClickNewOpportunity }: any) => {
    const [showModal, setShowModal] = useState(false);
    const displayName =
        childItem?.displayName ||
        childItem?.categoryName ||
        childItem?.name ||
        '수업';
    const title = `신규기회 · ${displayName}`;
    const memberName = childItem?.memberName || childItem?.alias || '회원 미정';
    const hoverStyle: CSSProperties = cellIndex > 5 ? { right: '110%' } : { left: '110%' };

    return (
        <Col
            onClick={() => onClickNewOpportunity?.(childItem)}
            style={{
                width: '95%',
                height: LEGACY_WEEKLY_BLOCK_HEIGHT,
                borderRadius: 4,
                border: '1.5px solid #F59E0B',
                alignItems: 'flex-end',
                marginBottom: 4,
                backgroundColor: '#FFFBEB',
                cursor: 'pointer',
                boxShadow: showModal ? '0px 0px 12px 0px rgba(245,158,11,0.28)' : '',
                position: 'relative',
            }}
            onMouseEnter={() => setShowModal(true)}
            onMouseLeave={() => setShowModal(false)}
        >
            <Col
                style={{
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Col
                    style={{
                        width: '92%',
                        height: 34,
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                    }}
                >
                    <Row style={{ alignItems: 'center', minWidth: 0, height: 16, gap: 6 }}>
                        <Body3Bold
                            style={{
                                color: '#B45309',
                                fontSize: 13,
                                lineHeight: '16px',
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                            }}
                        >
                            {childItem?.coachName} 강사
                        </Body3Bold>
                        <CaptionBold style={{ color: '#B45309', lineHeight: '16px', flexShrink: 0 }}>
                            신규
                        </CaptionBold>
                        <CaptionLight style={{ color: '#92400E', lineHeight: '16px', marginLeft: 'auto', flexShrink: 0 }}>
                            {dayjs(childItem?.startTime).format('HH:mm')}
                        </CaptionLight>
                    </Row>
                    <Row style={{ alignItems: 'center', minWidth: 0, height: 15 }}>
                        <Body3Bold
                            style={{
                                color: '#B45309',
                                fontSize: 13,
                                lineHeight: '15px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                minWidth: 0,
                                flex: 1,
                            }}
                        >
                            {title} · {memberName}
                        </Body3Bold>
                    </Row>
                </Col>
            </Col>

            {showModal && (
                <HoverItem style={hoverStyle} isVisible={showModal}>
                    <Row style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                        <Row style={{ width: 200 }}>
                            <Col
                                style={{
                                    width: 8,
                                    height: 22,
                                    borderRadius: 8,
                                    backgroundColor: '#F59E0B',
                                    marginRight: 11,
                                }}
                            />
                            <Body3Bold style={{ color: '#B45309' }}>{`${childItem?.coachName} 강사`}</Body3Bold>
                        </Row>
                    </Row>

                    <Body3Light style={{ color: '#374151', marginTop: 16 }}>
                        {dayjs(childItem?.startTime).format('M월 D일(ddd)')}
                    </Body3Light>
                    <Body3Bold style={{ color: '#374151', marginTop: 8 }}>
                        {dayjs(childItem?.startTime).format('A hh:mm ~ ')}
                        {dayjs(childItem?.endTime).format('A hh:mm ')}
                        {`(${childItem?.duration}분)`}
                    </Body3Bold>
                    <Body3Regular style={{ width: 252, color: '#374151', marginTop: 8 }}>
                        {memberName} · {title}
                    </Body3Regular>
                    {childItem?.memo && (
                        <Body3Regular
                            style={{
                                width: 252,
                                color: '#6B7280',
                                marginTop: 8,
                                lineHeight: '20px',
                            }}
                        >
                            {truncateString(childItem.memo, 44)}
                        </Body3Regular>
                    )}
                </HoverItem>
            )}
        </Col>
    );
};

export default NewOpportunityBlock;
